import { ElementRef } from '@angular/core';

export abstract class Validatable {
  abstract errorNode: ElementRef;
  abstract input: ElementRef;
}
